var UserPermissionNames: IUserPermissionNames = {
    USER_VIEW: "User.View",
    USER_MANAGE: "User.Manage",
    USER_SETTINGS: "User.Settings",
    ROLE_MANAGE: "Role.Manage",
    ENTITLEMENT_MANAGE: "Entitlement.Manage"
}

export default UserPermissionNames;
